import React from 'react';
import { studyCalculators_Fr } from '../ConstantsStudyCalculator';
import SharedHelmet from '.././Helmet';

const TITLE = 'Calculatrices d etudes, GPA et conversions de notes';
const DESCRIPTION = 'Utilisez des calculatrices d etudes en francais pour GPA, moyennes, equivalences internationales et conversions de notes. Ideal pour lyceens, etudiants et enseignants.';
const KEYWORDS = 'calculatrice GPA, conversion de notes, moyenne scolaire, equivalence notes, calcul etudes';
const OG_URL = 'https://do-calculate.com/fr/study-calculators/';

function StudyCalculatorsList() {
    return (
        <div className="container ltr-container">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
            <div>
                <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
                <hr />
                <div className="alert alert-info" role="alert">
                    <p>Toutes les conversions de notes utiles sont regroupees ici pour vous faire gagner du temps pendant l annee scolaire.</p>
                </div>
            </div>
            <hr />
            <table>
                <thead>
                    <tr>
                        <th>Calculatrice</th>
                        <th>Description</th>
                    </tr>
                </thead>
                <tbody>
                    {studyCalculators_Fr.map((calculator, index) => (
                        <tr key={index}>
                            <td>
                                <a href={calculator.link}> <h2 style={{ fontSize: '14px' }}>{calculator.name}</h2> </a>
                            </td>
                            <td><p>{calculator.description}</p></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <br />
        </div>
    );
}

export default StudyCalculatorsList;
